import { localized } from "@msuite/ui/localization";
import { createColumnHelper, createRowActions } from "@msuite/ui/table";
import { guardString } from "@msuite/utils/strings";
import type { IncomingInvoiceDeliveryNoteListItem } from "@msuite/utils/types";
import { formatInvoiceDate } from "@/components/incoming-invoices";
import { DeliveryNoteInvoiceCell } from "./delivery-note-invoice-cell";
import { DeliveryNoteNumberCell } from "./delivery-note-number-cell";
import { RowActions } from "./row-actions";

const columnHelper = createColumnHelper<IncomingInvoiceDeliveryNoteListItem>();

export const columns = [
	columnHelper.accessor("deliveryDate", {
		id: "deliveryDate",
		header: localized("incoming_invoices.delivery_notes.delivery_date"),
		cell: (cell) => formatInvoiceDate(cell.getValue()),
		size: 130,
	}),
	columnHelper.accessor("number", {
		id: "number",
		header: localized("incoming_invoices.delivery_notes.number"),
		cell: (cell) => <DeliveryNoteNumberCell deliveryNote={cell.row.original} />,
		size: 180,
	}),
	columnHelper.accessor("issuerName", {
		id: "issuerName",
		header: localized("incoming_invoices.supplier"),
		cell: (cell) => guardString(cell.getValue()),
	}),
	columnHelper.accessor("orderReference", {
		id: "orderReference",
		header: localized("incoming_invoices.delivery_notes.order_reference"),
		cell: (cell) => guardString(cell.getValue()),
		size: 160,
	}),
	columnHelper.accessor("positionCount", {
		id: "positionCount",
		header: localized("incoming_invoices.positions"),
		cell: (cell) => cell.getValue(),
		size: 110,
		meta: { isNumeric: true },
	}),
	columnHelper.accessor((row) => row.invoice?.number ?? null, {
		id: "invoice",
		header: localized("incoming_invoices.invoice"),
		cell: (cell) => <DeliveryNoteInvoiceCell invoice={cell.row.original.invoice} />,
		size: 190,
	}),
	createRowActions(RowActions),
];
